import axios from 'redaxios';
import MicroModal from 'micromodal';
import ProductSection from 'product';
// https://www.npmjs.com/package/@shopify/theme-sections/v/1.1.0
// import {unload, load, getInstances} from '../vendor/theme-scripts/theme-sections';
import * as sections from '../vendor/theme-scripts/theme-sections';

let quickShopSections = {};

const selectors = {
  quickShopButton: '[data-quick-shop]',
  quickShopContent: '[data-quick-shop-content]'
};

const classes = {
  loading: 'loading',
  success: 'has-success',
};


class ProductQuickShop {
  constructor(button) {
    this.button = button;
    this.initQuickShopButton();
  }

  initQuickShopButton() {
    this.button.addEventListener(
      'click',
      function (evt) {
        let enabled = ( evt.target.getAttribute('data-quick-shop') !== 'false' );

        if( !enabled ) {
          return;
        }

        evt.preventDefault();
        let productHandle = evt.target.getAttribute('data-product-handle'),
            url = `/products/${productHandle}`,
            quickShopContentElements = document.querySelectorAll(selectors.quickShopContent);

        quickShopContentElements.forEach((el) => {
          el.classList.add( classes.loading );
        });
        MicroModal.show('QuickShopModal');

        axios
          .get(url)
          .then(function (response) {
            // remove existing ajax product instances
            sections.unload( document.querySelector(`[data-section-type="product"][data-is-quick-shop="true"]`) );

            // create new quick-shop product div
            let dataDiv = document.createElement('div');
            dataDiv.innerHTML = response.data;

            let productSectionEl =  dataDiv.querySelector('[data-section-type="product"]'),
                sectionId = productSectionEl.getAttribute('data-section-id');
            productSectionEl.setAttribute('data-section-id', `quick-add--${sectionId}`);
            productSectionEl.setAttribute('data-is-quick-shop', 'true');

            // Make color swatches ajax
            const swatchEles = productSectionEl.querySelectorAll(`.swatch__button`);
            swatchEles.forEach((el) => {
              el.setAttribute('data-quick-shop', true);
            });

            quickShopContentElements.forEach((el) => {
              el.innerHTML = productSectionEl.outerHTML;
            });

            // Load all registered sections on the page.Ωå
            sections.load('product');

            quickShopContentElements.forEach((el) => {
              el.classList.remove( classes.loading );
            });
            // MicroModal.close('QuickShopModal');

            // Babylist
            let productJSON = null;
            let productElemJSON = productSectionEl.querySelector(`[data-product-json]`);
            if (productElemJSON) {
              productJSON = productElemJSON.innerHTML;
            }
            if (productJSON ) {
              productJSON = JSON.parse(productJSON);
              if( typeof(bl) == 'undefined' ) {
                return;
              }
              var addToBabylistButton = document.querySelector(`#add_to_babylist_button--${productJSON.id}`);
              addToBabylistButton.addEventListener("click", function() {
                var productInfo = {
                  images: [productJSON.featured_image],
                  price: ""+productJSON.price / 100.00,
                  title: productJSON.title,
                  url: `https://${window.location.host}/products/${productJSON.handle}`
                };
                bl.addToRegistry(productInfo);
              });
            } else {
              console.error('Missing product form or product JSON');
            }
          })
          .catch(function (error) {
            console.warn(error);
            // instance.onError(error.data);
          });
      }.bind(this)
    );
  }
}

const productQuickShop = {
  onLoad() {
    // console.log({
    //   'quickShopSections': quickShopSections
    // })
    quickShopSections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.quickShopButton);
    els.forEach((el) => {
      quickShopSections[this.id].push(new ProductQuickShop(el));
    });
  },
  onUnload: function () {
    quickShopSections[this.id].forEach((el) => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
};

export {ProductQuickShop, productQuickShop};
